export default class Tag {
  constructor(object) {
    this.id = object.id
    this.name = object.name
  }

  static fromJson(json) {
    return new Tag(json)
  }
}

export class TagWithMetrics extends Tag {
  constructor(object) {
    super(object)
    this.recruiters_count = object.recruiters_count
    this.cooperations_count = object.cooperations_count
    this.applicants_count = object.applicants_count
  }
}
